export default __webpack_public_path__ + "static/media/No.1-0.2465baab.jpg";